import { BsInfoSquareFill } from 'react-icons/bs';
import './InputHint.scss';

interface IProps {
  children?: any;
}

const InputHint: React.FC<IProps> = ({ children }) => {
  return (
    <div className="input-hint">
      <div className="input-hint-icon">
        <BsInfoSquareFill />
      </div>
      <div className="input-hint-text">{children ?? ''}</div>
    </div>
  );
};

export default InputHint;
